import React, { useRef } from "react";
import { Camera } from 'react-camera-pro';

export const WebcamCapture = ({ images, setConditionalStyleImage = () => { } }) => {
    const camera = useRef(null);
    const [imgSrcs, setImgSrcs] = React.useState([]);
    // const handleCapture = () => {
    //   const photo = camera.current.takePhoto();
    //   console.log("Captured base64:", photo);
    //   // you can set it in state or upload etc.
    // };
    const handleCapture = React.useCallback(() => {

        if (!camera.current) {
            console.warn("Camera not ready");
            return;
        }

        const imageSrc = camera.current.takePhoto();

        if (!imageSrc) {
            console.warn("No image captured.");
            return;
        }

        setImgSrcs((prev) => [...prev, imageSrc]);
        images(imageSrc); // if you want to send it up
        setConditionalStyleImage(false)
    }, [camera, setImgSrcs]);

    return (
        <div style={{ position: "relative", width: "100%", height: "500px" }}>
            {/* Camera with non-blocking style */}
            <Camera
                ref={camera}
                facingMode="environment"
                aspectRatio="cover"
                errorMessages={{
                    noCameraAccessible: "Camera not accessible",
                    permissionDenied: "Permission denied",
                }}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }}
            />

            {/* Overlay button */}
            <div
                style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 10,
                }}
            >
                <button
                    onClick={handleCapture}
                    style={{
                        padding: "10px 20px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        cursor: "pointer",
                    }}
                >
                    Capture
                </button>
            </div>
        </div>
    );
};
